import { IDatasheetComponentDto } from "@common/dto/datasheet/datasheet-component";

export enum DatasheetElementType {
  field = 'field',
  text = 'text',
}

export type DatasheetElementId = string;

export type DatasheetElement<DatasheetElementOriginalData extends IDatasheetComponentDto = IDatasheetComponentDto> = {
  id: DatasheetElementId;
  type: DatasheetElementType;
  original: DatasheetElementOriginalData;
  width: number;
  height: number;
  coordinates: { y: number; x: number };
};